export default "__VITE_ASSET__Tn_Cfq3a__"